import { render } from "./PimLabProductsOverviewTableItem.vue?vue&type=template&id=27a0ae2e&scoped=true&ts=true"
import script from "./PimLabProductsOverviewTableItem.vue?vue&type=script&lang=ts"
export * from "./PimLabProductsOverviewTableItem.vue?vue&type=script&lang=ts"

import "./PimLabProductsOverviewTableItem.vue?vue&type=style&index=0&id=27a0ae2e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a0ae2e"]])

export default __exports__